import { useEffect, useState } from "preact/hooks";

// shown when a product has no image (or the image fails to load)
const PlaceholderIcon = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M6 5V4.5A1.5 1.5 0 0 1 7.5 3h12A1.5 1.5 0 0 1 21 4.5v10a1.5 1.5 0 0 1-1.5 1.5H19" />
    <rect x="3" y="6" width="16" height="15" rx="1.5" />
    <circle cx="8" cy="10.5" r="1.5" />
    <path d="M3.5 19l4.5-4.5 3 3 2.5-2.5 5 5" />
  </svg>
);

const ProductImage = ({ src, alt, className, iconSize = 24 }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <div className={`${className} ppl-image-placeholder`} role="img" aria-label={alt}>
        <PlaceholderIcon size={iconSize} />
      </div>
    );
  }

  return <img className={className} src={src} alt={alt} onError={() => setFailed(true)} />;
};

export default ProductImage;
